export default class LocaleExtends {
	private locale: string = '';

	public getLocale(): string {
		return this.locale;
	}

	public setLocale(locale: string): void {
		this.locale = locale;
	}
}
